"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Video = /** @class */ (function () {
    function Video(width, height) {
        this.width = width;
        this.height = height;
        this.playing = false;
        this.videoElement = document.getElementById('video');
    }
    Video.prototype.startVideo = function () {
        var constraints = {
            audio: false,
            video: { width: this.width, height: this.height }
        };
        navigator.mediaDevices.getUserMedia(constraints)
            .then(this.success.bind(this))
            .catch(this.error);
    };
    Video.prototype.success = function (stream) {
        this.playing = true;
        this.videoElement.srcObject = stream;
    };
    Video.prototype.error = function (error) {
        console.log(error);
    };
    Video.prototype.stopVideo = function () {
        var stream = this.videoElement.srcObject;
        var tracks = stream.getTracks();
        tracks.forEach(function (track) {
            track.stop();
        });
        this.videoElement.srcObject = null;
        this.playing = false;
    };
    return Video;
}());
exports.default = Video;
